import { getRequestHeaders } from '@sgwt/react-shared-libs';
import { CancelTokenSource } from 'axios';
import { IStatus } from '../types';
import { ApiRepository } from './main repository/api.repository';

export namespace StatusService {
  const BASE_API = `${window.globalConfiguration.api.base}/v1/status`;

  export const getStatus = (cancelTokenSource: CancelTokenSource, withServiceConnection: boolean): Promise<IStatus> => {
    const headers = getRequestHeaders();
    return ApiRepository.Core().get(
      BASE_API,
      { withServiceConnection },
      {
        headers: {
          pragma: 'no-cache',
          'cache-control': 'no-cache',
          ...headers,
        },
        cancelToken: cancelTokenSource.token,
      }
    );
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  export const updateStatus = async (status: string, value: string): Promise<any> => {
    return ApiRepository.Core().put(BASE_API, { status, value });
  };
}
